import { Component, OnInit, OnDestroy } from "@angular/core";
import { MuestraService } from '../../servicios/muestra-servicios';
import { LogService } from "../../servicios/log-servicios";
import { FechaHoraService } from "../../../modulo-comunes/servicios/fechahora-servicios";
import { take, takeUntil } from "rxjs/operators";
import { Subject, Subscription } from "rxjs";
import { CoordCampo } from '../../interfaces/varias-interfaces';

@Component({
  selector: 'app-datepick-elem',
  templateUrl: './datepick-elem.component.html',
  styleUrls: ['./datepick-elem.component.css']
})
export class DatepickElemComponent implements OnInit, OnDestroy {
  private _onDestroy$: Subject<void> = new Subject();

  muestraDatepickSub: Subscription;
  muestraDatepick: boolean = false;
  dpFechaEleg: string = '';
  dpDatosCampo: CoordCampo = { left: '', top: '', width: '', height: '' };
  dpClase: string;
  dpRespuesta: string = '';

  fAnioHoy: string = '';        //yyyy
  fMes0Hoy: number = 0;         //0-11
  fMesHoy: string = '';         //'01' a '12'
  fDiaHoy: string = '';         //'01' a '31'

  fAnio: string = '';           //yyyy
  fMes0: number = 0;            //0-11
  fMes: string = '';            //'01' a '12'
  fDia: string = '';            //'01' a '31'
  fDiaSem0: number = 0;         //0 (domingo) - 6 (sábado) 
  fNombreMes: string = '';      //'Enero', ...
  fAbrevDia: string = '';       //'L', M, Mi ...

  fPrimerLunesCal: number = 0;  // (23-31-1)
  fUltDiaMesAnt: number = 0;    // (28-31)
  fAbrevDia1: string = '';      // (D L...) 
  fUltDiaMes: number = 0;       // (28-31) 
  fAbrevUltDiaMes: string = ''; // (D L...)
  fUltDomingoCal: number = 0;   // (28-31 1-6)
  fCantSemanas: number = 0;     // 4-5-6

  fCalendario: string[] = [];
  idxDia1: number = 0;
  idxUltDia: number = 0;

  fLunesArr: string[] = [];
  fMartesArr: string[] = [];
  fMiercolesArr: string[] = [];
  fJuevesArr: string[] = [];
  fViernesArr: string[] = [];
  fSabadoArr: string[] = [];
  fDomingoArr: string[] = [];

  anioOpciones: string[] = [];
  mesesOpciones: string[] = [];

  dpContenedor: HTMLElement;
  currentFocus: number = -1;
  itemFiltradoActivo: number;
  itemsFiltrados: number[];

  constructor(
    private muestraService: MuestraService,
    private logService: LogService,
    private fechaHoraService: FechaHoraService
  ) { }

  ngOnInit() {
    this.logService.consoleLog('2', 'CE DP init');
    this.muestraDatepickSub = this.muestraService.datepick$
      .pipe(takeUntil(this._onDestroy$))
      .subscribe(p => {
        this.muestraDatepick = p;
        if (this.muestraDatepick) {
          //leo los paráms para mostrar en el html
          this.logService.consoleLog('2', 'CE DP mDp true');
          this.dpFechaEleg = this.muestraService.dpFechaEleg;
          this.dpDatosCampo = this.muestraService.dpDatosCampo;
          this.dpClase = this.muestraService.dpClase;

          this.logService.consoleLog('2', 'CE DP mDp dpFechaEleg: ' + this.dpFechaEleg);
          this.dpRespuesta = '';
          setTimeout(() => {
            this.dpContenedor = <HTMLElement>document.getElementById('contenedor');
            this.dpContenedor.style.left = this.dpDatosCampo.left;
            this.dpContenedor.style.top = this.dpDatosCampo.top;
            this.dpContenedor.style.width = this.dpDatosCampo.width;
            this.dpContenedor.style.height = this.dpDatosCampo.height;
            this.logService.consoleLog('2', 'CE DP mDp Clase: ' + this.dpClase);
            this.llenarDatepick();
            //voy a usar combos para elegir el mes y el año
            this.fLlenaCombos();

            this.dpContenedor.style.display = "block";
          }, 100);
        } else {
          //nada
          this.logService.consoleLog('2', 'CE DP mDp Sub false');
        }
      })
  }

  ngOnDestroy() {
    //Esta técnica de this._onDestroy$ en ngOnDestroy
    //permite liberar todos los Observables que tengan un .takeUntil(this._onDestroy$)
    //Si un Observable tiene take(n) no requiere destruirse porque ya lo hace luego de leer n veces
    this.logService.consoleLog('2', 'CE DP cerrando datepick-elem.component');
    this._onDestroy$.next();
    this._onDestroy$.complete();
  }

  public baseOnClick() {
    setTimeout(() => {
      this.logService.consoleLog('2', 'CE CB baseOnClick');
      this.muestraService.ocultaDatepick(this.dpFechaEleg, 'Datepick cerrado con Esc o clic afuera');
    }, 100);
  }

  fLlenaCombos() {
    for (let i = 1900; i < 2050; i++) {
      this.anioOpciones.push(i.toString());
    }
    //this.anioOpciones = ['2021', '2022', '2023', '2024', '2025', '2026', '2027', '2028', '2029', '2030', '2031', '2032', '2033', '2034', '2035', '2036', '2037', '2038', '2039', '2040',];
    this.mesesOpciones = this.fechaHoraService.meses;
  }

  public abrirCombo(campo: string) {
    this.logService.consoleLog('2', 'CE DP abrirCombo: ' + campo);
    let dftVal: string;
    if (campo == 'txtAnio') {
      dftVal = this.fAnio;
      this.logService.consoleLog('2', 'CE DP muestraCombo Anio Opc: ' + this.anioOpciones[0]);
    } else if (campo == 'txtMes') {
      dftVal = this.fNombreMes;
      this.logService.consoleLog('2', 'CE DP muestraCombo Mes Opc: ' + this.mesesOpciones[0]);
    }

    const campoBase: HTMLInputElement = <HTMLInputElement>document.getElementById(campo);
    this.muestraService.disableScroll('segundo nivel');    //antes de leer las coordenadas porque al desaparecer el scroll cambia el width del campo.
    const campoBaseRect = campoBase.getBoundingClientRect();
    const datosCampo: CoordCampo = {
      left: campoBaseRect.left + 'px',
      top: campoBaseRect.top + 'px',
      width: campoBaseRect.width + 'px',
      height: campoBaseRect.height + 'px'
    };
    const campoBaseClass = campoBase.className;
    let opcionesCombo: string[];
    switch (campo) {
      case 'txtAnio':
        opcionesCombo = this.anioOpciones;
        break;
      case 'txtMes':
        opcionesCombo = this.mesesOpciones;
        break;
      default:
        break;
    }

    this.muestraService.ocultaDatepick('', 'Clic en input, no leer próximo mensaje Datepick cerrado');

    this.logService.consoleLog('2', 'CE DP prepara combo datos: ' + JSON.stringify(datosCampo));
    this.logService.consoleLog('2', 'CS DP prepara combo clase: ' + JSON.stringify(campoBaseClass));

    this.muestraService.muestraCombo(dftVal, opcionesCombo, false, datosCampo, campoBaseClass, 'N', 'N')
      .pipe(take(1))
      .subscribe(r => {
        this.logService.consoleLog('2', 'CE DP Respuesta: ' + r);
        if (r != 'Combo cerrado con Esc o clic afuera') {
          switch (campo) {
            case 'txtAnio':
              this.logService.consoleLog('2', 'CE DP cambio año: ' + r + '-' + this.fMes + '-01');
              this.muestraService.updateDpFechaEleg(r + '-' + this.fMes + '-01');
              this.dpFechaEleg = this.muestraService.dpFechaEleg;
              this.llenarDatepick();
              break;
            case 'txtMes': {
              const m: string = this.fechaHoraService.obtieneNumMes(r);
              this.logService.consoleLog('2', 'CE DP cambio mes: ' + this.fAnio + '-' + m + '-01');
              this.muestraService.updateDpFechaEleg(this.fAnio + '-' + m + '-01');
              this.dpFechaEleg = this.muestraService.dpFechaEleg;
              this.llenarDatepick();
              break;
            }
            default:
              break;
          }
          //this.llenarDatepick
        }
        //en este caso no habilito el scroll al cerrar el combo porque todavía sigue abierto el datepick
        //this.logService.consoleLog('2', 'CE DP enable scroll');
        //this.muestraService.enableScroll();
      });
  }

  private llenarDatepick() {
    this.fCalendario = [];
    this.fLunesArr = [];
    this.fMartesArr = [];
    this.fMiercolesArr = [];
    this.fJuevesArr = [];
    this.fViernesArr = [];
    this.fSabadoArr = [];
    this.fDomingoArr = [];
    this.idxDia1 = 0;
    this.idxUltDia = 0;

    this.logService.consoleLog('2', "CE DP llenar");

    //esta rutina prepara meses y diasSem y trae estos datos: 
    //fAnio ('yyyy'), fMes0 (0-11), fMes ('01'-'12'), fDia ('01'-'31'), fDiaSem0 (0-6), fNombreMes, fAbrevDia (D L M Mi ...), 
    //fPrimerLunesCal (23-31-1), fAbrevDia1 (D L...), fUltDiaMes (28-31), fAbrevUltDia (D L...), fUltDomingoCal (28-31 1-6) 
    this.datosCalendario(this.muestraService.dpFechaEleg);

    //esta rutina llena un array con los días que deben ir en el calendario
    //idxDia1 e idxUltDia indican los elementos del array que son parte del mes
    let offset1: number = 0;
    let offset2: number = 0;

    this.logService.consoleLog('2', "CE DP fCantSemanas: " + this.fCantSemanas);

    for (let i = 0; i < this.fCantSemanas * 7; i++) {
      this.logService.consoleLog('2', "CE DP i: " + i);
      if (i <= 6) {  //primera semana, puede tener días del mes anterior
        if (this.fPrimerLunesCal == 1) {
          //el dia 1 es lunes, es decir el calendario no tiene días del mes pasado
          this.fCalendario.push((i + 1).toString());
          this.idxDia1 = 0;
          offset1 = -1;
        } else {
          //el primer lunes pertenece al mes pasado
          if (i + this.fPrimerLunesCal <= this.fUltDiaMesAnt) {
            //sigue en el mes pasado
            this.fCalendario.push((i + this.fPrimerLunesCal).toString());
            //se guarda el último i del mes pasado como offset1
            offset1 = i;
          } else {
            //empieza el mes actual
            if (this.idxDia1 == 0) {
              //solo la primera vez que entro acá guardo estas variables
              this.idxDia1 = i;
            }

            this.fCalendario.push((i - offset1).toString());
            this.idxDia1 = i;
          }
        }
      } else if (i <= this.fUltDiaMes + offset1) {
        //sigue en el mes actual
        this.fCalendario.push((i - offset1).toString());
      } else {
        //pasa al mes próximo
        if (this.idxUltDia == 0) {
          //solo la primera vez que entro acá guardo estas variables
          this.idxUltDia = i;
          offset2 = i - 1;
        }
        this.fCalendario.push((i - offset2).toString());
      }
      this.logService.consoleLog('2', 'CE DP fCalendario[' + i + '] = ' + this.fCalendario[i]);
    }

    //Ahora lleno los arreglos de cada día de la semana:
    for (let semanaActual = 0; semanaActual < this.fCantSemanas; semanaActual++) {
      this.fLunesArr.push(this.fCalendario[semanaActual * 7 + 0]);
      this.fMartesArr.push(this.fCalendario[semanaActual * 7 + 1]);
      this.fMiercolesArr.push(this.fCalendario[semanaActual * 7 + 2]);
      this.fJuevesArr.push(this.fCalendario[semanaActual * 7 + 3]);
      this.fViernesArr.push(this.fCalendario[semanaActual * 7 + 4]);
      this.fSabadoArr.push(this.fCalendario[semanaActual * 7 + 5]);
      this.fDomingoArr.push(this.fCalendario[semanaActual * 7 + 6]);
    }
  }

  public asignaClase(numSem: number, strDiaMes: string): string {
    strDiaMes = strDiaMes.length == 1 ? '0' + strDiaMes : strDiaMes;
    this.logService.consoleLog('2', 'CE DP clase: Sem: ' + numSem + ', Día:' + strDiaMes + '; Hoy/Eleg/Orig: ' + this.fAnioHoy + '-' + this.fMesHoy + '-' + this.fDiaHoy + ' ' + this.fAnio + '-' + this.fMes + '-' + this.fDia + ' ' + this.muestraService.dpFechaElegOrig);
    let c: string = 'txtdia';
    if ((numSem == 0 && parseInt(strDiaMes) > 20) || (numSem > 3 && parseInt(strDiaMes) < 7)) {
      this.logService.consoleLog('2', 'CE DP asignaClase fuerames');
      c = 'fuerames'
    } else {
      if (this.fAnioHoy == this.fAnio && this.fMesHoy == this.fMes && this.fDiaHoy == strDiaMes) {
        this.logService.consoleLog('2', 'CE DP asignaClase ACTUAL');
        c = c + ' actual';
      } else if (this.muestraService.dpFechaElegOrig == (this.fAnio + '-' + this.fMes + '-' + strDiaMes)) {
        this.logService.consoleLog('2', 'CE DP asignaClase activo');
        c = c + ' activo';
      }
    }
    return c;
  }

  public emitirRespuesta(numSem: number, strDiaMes: string) {
    strDiaMes = strDiaMes.length == 1 ? '0' + strDiaMes : strDiaMes;
    this.logService.consoleLog('2', 'CE DP Emitir respuesta: numSem: ' + numSem + ', strDiaMes:' + strDiaMes);
    let resp: string = '';
    if ((numSem == 0 && parseInt(strDiaMes) > 20) || (numSem > 3 && parseInt(strDiaMes) < 7)) {
      //'fuerames', no hacer nada
    } else {
      resp = this.fAnio + '-' + this.fMes + '-' + strDiaMes;
      this.logService.consoleLog('2', 'CE DP Respuesta:' + resp);
      this.muestraService.ocultaDatepick(resp, '.');
    }
  }

  private datosCalendario(pFecha: string) {
    this.fechaHoraService.datosCalendario(pFecha);
    this.fAnioHoy = this.fechaHoraService.fAnioHoy;
    this.fMes0Hoy = this.fechaHoraService.fMes0Hoy;
    this.fMesHoy = this.fechaHoraService.fMesHoy;
    this.fDiaHoy = this.fechaHoraService.fDiaHoy;

    this.fAnio = this.fechaHoraService.fAnio;
    this.fMes0 = this.fechaHoraService.fMes0;
    this.fMes = this.fechaHoraService.fMes;
    this.fDia = this.fechaHoraService.fDia;
    this.fDiaSem0 = this.fechaHoraService.fDiaSem0;
    this.fNombreMes = this.fechaHoraService.fNombreMes;
    this.fAbrevDia = this.fechaHoraService.fAbrevDia;
    this.fPrimerLunesCal = this.fechaHoraService.fPrimerLunesCal;
    this.fUltDiaMesAnt = this.fechaHoraService.fUltDiaMesAnt;
    this.fAbrevDia1 = this.fechaHoraService.fAbrevDia1;
    this.fUltDiaMes = this.fechaHoraService.fUltDiaMes;
    this.fAbrevUltDiaMes = this.fechaHoraService.fAbrevUltDiaMes;
    this.fUltDomingoCal = this.fechaHoraService.fUltDomingoCal;
    this.fCantSemanas = this.fechaHoraService.fCantSemanas;

    this.logService.consoleLog('2', 'CE DP fecha: ' + this.fAnio + '-' + this.fMes + '-' + this.fDia + ' ' + this.fNombreMes + ' ' + this.fAbrevDia);
    this.logService.consoleLog('2', 'CE DP otros: ' + this.fPrimerLunesCal + ' ' + this.fAbrevDia1 + ' ' + this.fDia + ' ' + this.fUltDiaMes + ' ' + this.fAbrevUltDiaMes + ' ' + this.fUltDomingoCal);
  }

}
